import hardcodedTranslations from '@/locales/hardcodedTranslations';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const StyledHint = styled.p`
  margin: 0;
  font-size: var(--xsmall-font-size);
  color: var(--black-main);
`;

interface QuizMultiChoiceHintProps {
  show: boolean;
  language: string;
}

export const QuizMultiChoiceHint: React.FC<QuizMultiChoiceHintProps> = ({
  show,
  language,
}) => {
  if (!show) {
    return null;
  }

  return (
    <StyledHint>
      {hardcodedTranslations.quiz.answer.selectAllOptionsThatApply[language]}
    </StyledHint>
  );
};

const StyledAddOptionButton = styled.button`
  width: 100%;
  padding: var(--small-padding) 0; // spec: 11px vertical → rounded up to --small-padding (12px)
  border: 1px solid var(--gray-dark);
  border-radius: var(--xsmall-border-radius);
  background: transparent;
  color: #9b9b9b; // No matching token
  font-size: var(--small-font-size);
  cursor: pointer;

  &:hover {
    background: var(--gray-soft);
  }
`;

interface QuizAddOptionButtonProps {
  onClick: () => void;
}

export const QuizAddOptionButton: React.FC<QuizAddOptionButtonProps> = ({
  onClick,
}) => {
  const { t } = useTranslation();

  return (
    <StyledAddOptionButton type="button" onClick={onClick}>
      + {t('content.quizEditor.addOption')}
    </StyledAddOptionButton>
  );
};
